const deviceName = {
    androidtv: 'Android TV',
    appletv: 'Apple TV',
    tvOS: 'Apple TV',
    firetv: 'Fire TV',
    roku: 'Roku',
    ps3: 'PS3',
    ps4: 'PS4',
    xbox: 'Xbox',
    xboxone: 'Xbox One'
};

export const INVALID_MESSAGE = 'Invalid activate code!';
export const DEFAULT_VALUE = 'initialValue'; // empty value might hit the affilites w/o abbreviation in the console

export const WEB_STAGE_ONE_ID_API_PATH = 'https://stg.registerdisney.go.com/jgc/v6/client/ESPN-ONESITE.WEB-STAGE';
export const WEB_PROD_ONE_ID_API_PATH = 'https://registerdisney.go.com/jgc/v6/client/ESPN-ONESITE.WEB-PROD';
export const WEB_ESPN_PLUS_PURCHASE_PATH_QA = 'https://qa-secure.web.plus.espn.com/billing/purchase';
export const WEB_ESPN_PLUS_PURCHASE_PATH_PROD = 'https://secure.web.plus.espn.com/billing/purchase';

export default deviceName;



// WEBPACK FOOTER //
// ./app/webapp/page/Activate/constants.js